export function uniqueId(): string {
  return window.crypto.randomUUID();
}
